import { ApiBackClient } from '../../../services/apiADA';
import { saveInSessionStorage } from '../../../contexts/LocalStorage';

export function buscarPedidosAprovacaoERP(username, codcli, numped, codEmp, sitped, tipped, token) {
    return new Promise((resolve, reject) => {
        ApiBackClient.post("/consultapedidos", { "nomcli": codcli, "numped": numped, "codemp":codEmp, "sitped": sitped, "tipped": tipped, "tipvis": "A" },
            {
                headers: {
                    'Content-Type': 'application/json',
                    username: username,
                    Authorization: `Bearer ${token}`
                },
                baseURL: localStorage.getItem("base_url")
            })
            .then(res => {
                saveInSessionStorage("logid", res.headers.logid);
                if (res.data === '') {
                    console.error(res.data);
                    reject({ cod: 1, error: "Retorno inválido do sistema!" });
                } else {
                    resolve(res.data);
                }
            })
            .catch(function (error) {
                consoleLogErros(error);
                if (error.response !== undefined && error.response.data !== undefined && error.response.data.error !== undefined) {
                    reject({ cod: 1, error: error.response.data.error });
                } else {
                    reject({ cod: 1, error: error });
                }
            });
    });
}

export function aprovarRecusarPedido(pedido, codEmp, obs, tipo, token, username) {
    return new Promise((resolve, reject) => {
        ApiBackClient.post("/controle", { "pedctr": pedido, "codemp":codEmp, "obsctr": obs, "tipctr": tipo },
            {
                headers: {
                    'Content-Type': 'application/json',
                    username: username,
                    Authorization: `Bearer ${token}`
                },
                baseURL: localStorage.getItem("base_url")
            })
            .then(res => {
                saveInSessionStorage("logid", res.headers.logid);
                if (res.data === '') {
                    console.error(res.data);
                    reject({ cod: 1, error: "Retorno inválido do sistema!" });
                } else {
                    resolve(res.data);
                }
            })
            .catch(function (error) {
                consoleLogErros(error);
                if (error.response !== undefined && error.response.data !== undefined && error.response.data.error !== undefined) {
                    reject({ cod: 1, error: error.response.data.error });
                } else {
                    reject({ cod: 1, error: error });
                }
            });
    });
}
export function buscarPendenciasPedidos(pedido, codEmp, token, username) {; 
    return new Promise((resolve, reject) => {
        ApiBackClient.post("/pedidobloqueio", { "numped": pedido, "codemp": codEmp},
            {
                headers: {
                    'Content-Type': 'application/json',
                    username: username,
                    Authorization: `Bearer ${token}`
                },
                baseURL: localStorage.getItem("base_url")
            })
            .then(res => {
                console.error(res?.data);
              saveInSessionStorage("logid", res?.headers?.logid);
               if (res.data === '') {
                    console.error(res.data);
                    reject({ cod: 1, error: "Retorno inválido do sistema!" });
                } else {
                    resolve(res.data);
                    //console.log(res.data);
                } 
            })
            .catch(function (error) {
                consoleLogErros(error);
                if (error.response !== undefined && error.response.data !== undefined && error.response.data.error !== undefined) {
                    reject({ cod: 1, error: error.response.data.error });
                } else {
                    reject({ cod: 1, error: error });
                }
            });
    });
}

function consoleLogErros(error) {
    console.log("error validação");
    console.log(error);
    if (error.response) {
        // Requisição feita e o servidor retornou um erro
        console.error(error.response.data);
        console.error(error.response.status);
        console.error(error.response.headers);
    } else if (error.request) {
        // A requisição foi feita, mas nenhuma resposta foi recebida
        console.error(error.request);
    } else {
        // Alguma coisa aconteceu nas configurações da requisição que gerou um erro
        console.error('Error', error.message);
    }
}